import React from 'react';
import Grid from '../Grid';
var Form = function (_a) {
    var children = _a.children;
    return React.createElement(Grid, { container: true }, children);
};
export default Form;
//# sourceMappingURL=Form.js.map